import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonFunction } from '../helpers/commonFunction';
import { UserDetailService } from './user-detail.service';

@Injectable({
  providedIn: 'root'
})
export class UserMasterPssService {

  constructor(private http: HttpClient, private userDetailService: UserDetailService, private commonFunction: CommonFunction) { }


  getUserList(): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'userMaster/getUserList';
    return this.http.get(url, { headers: headers }).toPromise()
      .then(response => {
        return Promise.resolve(response => response.json());
      })
      .catch(this.handleError)
  }


  getAssociatedCompanyList(uniqueUserId): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'userMaster/getAssociatedCompanyList/' + uniqueUserId;
    return this.http.get(url, { headers: headers }).toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(this.handleError)
  }

  getRoleListOfUser(): Promise<any> {
    var token = localStorage.getItem('token');
    const url = environment.clientUrl + 'roleMaster/getUserRoles';
    var headers = this.addGovevaHeaders();
    return this.http.post(url, { headers: token }, { headers: headers }).toPromise()
      .then(response => {
        console.log('user roles', response => response.json())
        return Promise.resolve(response => response.json());
      })
      .catch(this.handleError)
  }


  createUser(userObject): Promise<any> {
    userObject = {encryptedToken: this.commonFunction.encrypt(JSON.stringify(userObject))};
    const url = environment.nonValidateUrl + 'user/register';
    return this.http.post(url, userObject).toPromise()
      .then(response => {
        return Promise.resolve(response => response.json());
      })
      .catch(this.handleError)
  }

  deactivateUser(idObject): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'userMaster/deactivate/' + idObject;
    return this.http.get(url, { headers: headers }).toPromise()
      .then(response => {
        return Promise.resolve(response => response.json());
      })
      .catch(this.handleError)
  }

  getSingleCompanyData(companyID): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'companyMaster/getSingleCompanyCompanyData/' + companyID;
    return this.http.get(url, { headers: headers }).toPromise()
      .then(response => {
        return Promise.resolve(response => response.json());
      })
      .catch(this.handleError)
  }

  getCompanyList(): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'companyMaster/companyListForUserManagement';
    return this.http.get(url, { headers: headers }).toPromise()
      .then(response => {
        return Promise.resolve(response => response.json());
      })
      .catch(this.handleError)
  }

  activateUser(object): Promise<any> {
    object = {encryptedToken: this.commonFunction.encrypt(JSON.stringify(object))};
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'user/activateUser';
    return this.http.post(url, object, { headers: headers }).toPromise()
      .then(response => {
        return Promise.resolve(response => response.json());
      })
      .catch(this.handleError)
  }


  // edit 
  getUserByUserId(userId): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'user/getUserByUserId/' + userId;
    return this.http.get(url, { headers: headers }).toPromise()
      .then((response: any) => {
        response = response.json()
        response.userDetails = JSON.parse(this.commonFunction.decrypt(response.userDetails))
        return Promise.resolve(response);
      })
      .catch(this.handleError)
  }

  editUser(userObject): Promise<any> {
    const url = environment.clientUrl + 'user/editProfile';
    var headers = this.addGovevaHeaders();
    userObject = {encryptedToken: this.commonFunction.encrypt(JSON.stringify(userObject))};
    return this.http.post(url, userObject, { headers: headers }).toPromise()
      .then((response: any) => {
        return Promise.resolve(response.json());
      })
      .catch(this.handleError)
  }

  getActiveCSMakerUsers(): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'user/getCSMakerUsers';
    return this.http.get(url, { headers: headers }).toPromise()
      .then((response: any) => {
        return Promise.resolve(response.json());
      })
      .catch(this.handleError)
  }

  getActiveCSCheckerUsers(): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'user/getCSCheckerUsers';
    return this.http.get(url, { headers: headers }).toPromise()
      .then((response: any) => {
        return Promise.resolve(response.json());
      })
      .catch(this.handleError)
  }

  getActiveICMakerUsers(): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'user/getICMakerUsers';
    return this.http.get(url, { headers: headers }).toPromise()
      .then((response: any) => {
        return Promise.resolve(response.json());
      })
      .catch(this.handleError)
  }

  getActiveICCheckerUsers(): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'user/getICChecekrUsers';
    return this.http.get(url, { headers: headers }).toPromise()
      .then((response: any) => {
        return Promise.resolve(response.json());
      })
      .catch(this.handleError)
  }

  //get Titles(salutations)
  getSalutationTitle(): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'user/salutationTitle';
    return this.http.get(url, { headers: headers }).toPromise()
      .then((response: any) => {
        return Promise.resolve(response.json());
      })
      .catch(this.handleError)
  }

  //get Committee list
  getCommitteeList(): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.pssServerUrl + 'committee';
    return this.http.get(url, { headers: headers }).toPromise()
      .then((response: any) => {
        return Promise.resolve(response.json());
      })
      .catch(this.handleError)
  }

  getAdminRoles(): Promise<any> {
    var headers = this.addGovevaHeaders();
    const url = environment.clientUrl + 'roleMaster/getAdminRoles';
    return this.http.get(url, { headers: headers }).toPromise()
      .then((response: any) => {
        console.log('Admin roles', response.json())
        return Promise.resolve(response.json());
      })
      .catch(this.handleError)
  }



  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
  // Pss--------------------------------->>>>>>>


  getExistingUsersList() {
    // console.log('updatedDocumentManagement');
    var headers = this.addHeaders();

    return this.http.get(environment.pssServerUrl + 'userMaster/getUniqueUserList', { headers: headers })
      .map((res: Response) => res.json());
  }



  addHeaders() {
    var PSSDetail = this.userDetailService.pssDetail();
    var UserDetail = this.userDetailService.getUserDetail();


    var getUserID = this.userDetailService.getUserID();
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    headers.append('PSSDetail', PSSDetail);
    headers.append('UserDetail', UserDetail);
    return headers;
  }


  addGovevaHeaders() {
    var companyDetails = this.userDetailService.govevaDetail();
    var PSSDetail = this.userDetailService.pssDetail();

    // var UserDetail = this.userDetailService.getUserDetail();
    var getUserID = this.userDetailService.getUserID();
    var headers = new HttpHeaders();

    headers.append('Content-Type', 'application/json');
    if (companyDetails && companyDetails !== 'null' && companyDetails !== 'undefined') {
      headers.append('govevacompany', companyDetails);
    }
    var token = localStorage.getItem('token')
    if (token) {
      headers.append("x-access-token", token);
    }
    // headers.append('PSSDetail', PSSDetail);
    // headers.append('UserDetail', UserDetail);
    return headers;
  }


  getSubsideryList(): Promise<any> {
    var headers = this.addGovevaHeaders();
    return this.http.get(environment.clientUrl + 'companyMaster/companyData', { headers: headers })
      .toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
  }


  getDepartment = () => {
    return new Promise((resolve, reject) => {
    const url = environment.pssServerUrl + 'department/master';
    return this.http.get(url).toPromise()
      .then(response => {
        return resolve(response);
      })
      .catch(this.handleError)
    })
  }

  getBranch = () => {
    return new Promise((resolve, reject) => {
      const url = environment.pssServerUrl + 'brnch/master';
      return this.http.get(url).toPromise()
        .then(response => {
          return resolve(response);
        })
        .catch(this.handleError)
    })
  }

  
}
